import { footballStatKeyToNameMap, rugbyLeagueStatKeyToNameMap, rugbyUnionStatKeyToNameMap, FootballFactStatMap, RugbyLeagueFactStatMap, RugbyUnionFactStatMap } from '@ligr/api-v2';
export const statKeyToNameMapBySport = {
    football: footballStatKeyToNameMap,
    'rugby league': rugbyLeagueStatKeyToNameMap,
    'rugby union': rugbyUnionStatKeyToNameMap
};
export const factStatMapBySport = {
    football: FootballFactStatMap,
    'rugby league': RugbyLeagueFactStatMap,
    'rugby union': RugbyUnionFactStatMap
};
export const mapFactNameBySport = (sportName, factName) => {
    //@ts-ignore
    return statKeyToNameMapBySport[sportName][
    //@ts-ignore
    factStatMapBySport[sportName][factName]];
};
//# sourceMappingURL=index.js.map